export const isMobileDevice = () => {
  // Use the most reliable method: check for touch support
  const hasTouchSupport =
    'maxTouchPoints' in navigator && navigator.maxTouchPoints > 0;

  // If touch support is not available, use user agent string detection as a fallback (less reliable)
  if (!hasTouchSupport) {
    const userAgent = navigator.userAgent;
    const mobileRegex =
      /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileRegex.test(userAgent);
  }

  return hasTouchSupport;
};
